// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"ErrorPopUp-module-imgWrapper--PNxfd","buttonBox":"ErrorPopUp-module-buttonBox--57OEW","mainButton":"ErrorPopUp-module-mainButton--wUmRF"};